import { SearchItem } from './module';
import { WatchlistId } from '@benzinga/watchlist-manager';

export const WatchlistModuleId = 'Watchlist' as const;

//Legacy

//V1
export interface WatchlistSearchItemDataV1 {
  watchlistId: WatchlistId;
}

export const WatchlistSearchItemVersionV1 = '1' as const;

export interface WatchlistSearchItemV1 extends SearchItem<WatchlistSearchItemDataV1> {
  version: typeof WatchlistSearchItemVersionV1;
  moduleId: typeof WatchlistModuleId;
}

export type LegacyWatchlistSearchItem = WatchlistSearchItemV1;

// Current

export type WatchlistSearchItemData = WatchlistSearchItemDataV1;

export const WatchlistSearchItemVersion = WatchlistSearchItemVersionV1;

export type WatchlistSearchItem = WatchlistSearchItemV1;

export const createWatchlistSearchItem = (watchlistId: string): WatchlistSearchItem => ({
  data: {
    watchlistId: watchlistId,
  },
  id: watchlistId,
  moduleId: WatchlistModuleId,
  version: WatchlistSearchItemVersion,
});

export const isLegacyWatchlistSearchItem = (item: SearchItem): item is LegacyWatchlistSearchItem =>
  item.moduleId === WatchlistModuleId;

export const isWatchlistSearchItem = (item: SearchItem): item is WatchlistSearchItem =>
  item.moduleId === WatchlistModuleId && item.version === WatchlistSearchItemVersion;
